exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".teaser-item{position:relative;min-height:270px}.teaser-item>.teaser-text{margin-bottom:50px;margin-left:600px}.teaser-item>h4{margin-left:600px}.teaser-item>.link-external{font-weight:600;margin-left:600px}.teaser-item>.button-control{position:absolute;right:0}.teaser-item>.teaser-img{position:absolute;top:50%;transform:translateY(-50%);display:block;height:270px;width:570px;border-radius:6px;overflow:hidden;margin-right:30px;border-bottom:3px solid #e5e6e6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69c1c413","scoped":false,"hasInlineConfig":true}!./src/components/teaser-item/teaser-item.css
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-69c1c413","scoped":false,"hasInlineConfig":true}!./src/components/teaser-item/teaser-item.css
// module chunks = index